/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './Toaster.scss';

import classnames from 'classnames';
import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/check-circle-filled.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/warning-circle-filled.svg';
import Store from 'state/Store';
import { emptyToaster } from 'state/toast/ToastActions';
import { withRouter } from 'react-router-dom';

export const Toaster = ({ toaster }) => {
  if (!isEmpty(toaster)) {
    const { message, success, title } = toaster;
    const toastClassName = classnames('toast', {
      'toast-success': success,
      'toast-failure': !success
    });
    const closeToast = () => Store.dispatch(emptyToaster());
    if (success) {
      setTimeout(function () {
        Store.dispatch(emptyToaster());
      }, 3000);
    }
    return (
      <div className={toastClassName}
           data-metrics-location="ALRT">
        {success ? (
          <CheckIcon className="status-icon" />
        ) : (
          <WarningIcon className="status-icon" />
        )}
        <div className="toast-content">
          <div className="toast-title">{title}</div>
          {typeof message == 'string' ? message : message()}
        </div>
        <CloseIcon className="close-icon" onClick={closeToast} />
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state) => ({
  toaster: state.toaster
});

export default withRouter(connect(mapStateToProps)(Toaster));